export function ClerkIcon(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6603_2)">
        <ellipse
          cx="7.99999"
          cy="8"
          rx="2.49999"
          ry="2.5"
          fill="var(--primaryTextColor)"
        />
        <path
          d="M12.5044 13.9189C12.7171 14.1316 12.6957 14.4837 12.4458 14.6511C11.1742 15.5029 9.64481 15.9996 7.99937 15.9996C6.35393 15.9996 4.82452 15.5029 3.55293 14.6511C3.30301 14.4837 3.28165 14.1316 3.49435 13.9189L5.32132 12.0919C5.48644 11.9268 5.7426 11.9007 5.95043 12.0072C6.56498 12.322 7.26143 12.4996 7.99937 12.4996C8.73732 12.4996 9.43377 12.322 10.0483 12.0072C10.2561 11.9007 10.5123 11.9268 10.6774 12.0919L12.5044 13.9189Z"
          fill="var(--primaryTextColor)"
        />
        <path
          d="M12.4464 1.3485C12.6963 1.5159 12.7177 1.86804 12.505 2.08074L10.678 3.90772C10.5129 4.07284 10.2567 4.09893 10.0489 3.99246C9.43435 3.67763 8.7379 3.5 7.99996 3.5C5.51469 3.5 3.49998 5.51472 3.49998 8C3.49998 8.73794 3.67761 9.4344 3.99244 10.0489C4.09891 10.2568 4.07283 10.5129 3.90771 10.6781L2.08074 12.505C1.86804 12.7177 1.51589 12.6964 1.34849 12.4465C0.496761 11.1749 0 9.64544 0 8C0 3.58172 3.5817 0 7.99996 0C9.6454 0 11.1748 0.496765 12.4464 1.3485Z"
          fill="#9394A1"
        />
      </g>
      <defs>
        <clipPath id="clip0_6603_2">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
